export const WORKS_TAB_MAP = {
  LATEST_RELEASE: {
    name: "最新",
    value: "LATEST_RELEASE",
    width: "0.57rem"
  },
  POPULARITY: {
    name: "人气乡村",
    value: "POPULARITY",
    width: "1.13rem"
  },
  RECOMMEND: {
    name: "评委推荐",
    value: "RECOMMEND",
    width: "1.13rem"
  },
  ACTIVITY_CATEGORY: {
    name: "参评项目",
    value: "ACTIVITY_CATEGORY",
    type: "",
    width: ""
  },
  AREA: {
    name: "报名地区",
    value: "AREA",
    type: "select",
    width: "1.38rem"
  },
  WORKSTYPE: {
    name: "作品类型",
    value: "WORKSTYPE",
    type: "select",
    width: "1.38rem"
  }
}

export const USER_INFO_FORM_MAP = {
  HEAD: {
    component: "FormItemHeader",
    label: "头像",
    placeholder: "",
    key: "HEAD"
  },
  ADVISOR: {
    component: "FormItemTeacher",
    label: "指导老师",
    placeholder: "",
    key: "ADVISOR"
  },
  ADVISOR_PHONE: {
    component: "FormItemPhone",
    label: "指导老师电话",
    placeholder: "",
    key: "ADVISOR_PHONE"
  },
  NAME: {
    component: "FormItemName",
    label: "姓名",
    placeholder: "",
    key: "NAME"
  },
  SCHOOL: {
    component: "FormItemSchool",
    label: "学校",
    placeholder: "",
    key: "SCHOOL"
  },
  AREA: {
    component: "FormItemLocation",
    label: "地区",
    placeholder: "",
    key: "AREA"
  },
  GRADE: {
    component: "FormItemGrade",
    label: "年级",
    placeholder: "",
    key: "GRADE"
  },
  COMPANY: {
    component: "FormItemUnit",
    label: "单位",
    placeholder: "",
    key: "COMPANY"
  }
}

export const GRADE_LIST = [
  {
    label: "一年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "二年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "三年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "四年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "五年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "六年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "初一年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "初二年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "初三年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "高一年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "高二年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "高三年级",
    value: "",
    key: "GRADE"
  },
  {
    label: "2016级",
    value: "",
    key: "GRADE"
  },
  {
    label: "2017级",
    value: "",
    key: "GRADE"
  },
  {
    label: "2018级",
    value: "",
    key: "GRADE"
  },
  {
    label: "2019级",
    value: "",
    key: "GRADE"
  }
]

export const FORM_ERR_AMP = {
  ADVISOR: "请填写联系人",
  ADVISOR_PHONE: "请填写联系人手机号",
  NAME: "请填写市县(市、区)",
  SCHOOL: "请填写学校",
  AREA: "请填写地区",
  GRADE: "请填写年级",
  COMPANY: "请选择参评地市"
}

export const FILE_TYPE_MAP = {
  PICTURE: "image",
  VIDEO: "video"
}

export const EXAMINE_TYPE_MAP = {
  WAIT: "审核中",
  PASS: "审核通过",
  REJECT: "审核未通过",
  REVOKE: "审核未通过",
  FIRST_PASS: "一审通过",
  FIRST_REJECT: "一审不通过"
}

export const USER_INFO_KEY_MAP = {
  HEAD: "headImg",
  NAME: "userName",
  AREA: "area",
  SCHOOL: "school",
  GRADE: "grade",
  ADVISOR: "advisor",
  ADVISOR_PHONE: "advisorPhone",
  COMPANY: "company"
}

export const FILTER_USER_FORM = {
  GRADE: 1,
  ADVISOR: 1,
  ADVISOR_PHONE: 1,
  COMPANY: 1
}

export const WORKS_INFO_INSERT_SIGN = {
  userName: {
    value: "[#USER_NAME#]",
    label: "用户名"
  },
  worksName: {
    value: "[#WORKS_NAME#]",
    label: "作品名称"
  },
  advisor: {
    value: "[#ADVISOR#]",
    label: "指导老师"
  },
  activityName: {
    value: "[#ACTIVITY_NAME#]",
    label: "活动名称"
  }
}
